import type { FaireProductEntity } from "../../entity_types/product";

export const p_dv4jtvctj9: FaireProductEntity = {
  token: "p_dv4jtvctj9",
  type: "product",
  name: "Valentine Textured Hair Bow",
  brandToken: "b_aysyz36773",
  brandName: "The Heady Chic",
  imageUrl:
    "https://cdn.faire.com/fastly/7644fa35bf7ccc9c7173360641ffdf120be49723d4d499748ddea316331c9aca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9beca01c1cbc8ac83f285ff31c9e37a36acf0d64244764e76198b4a8f31d9a0.jpeg",
  ],
  priceDollars: 8,
  description:
    "Whether you are dressing up for a special event or simple spreading love and cheer, these Valentine’s Day hair bows are for you!! Perfect for any occasion.\n\nMaterial: made from a variety of red, pink, and white ribbons.\n\nWe always ask that you carefully handle your hair bow with care, especially when opening the package. \n",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:39.189Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
